import { render, staticRenderFns } from "./add-driver.vue?vue&type=template&id=046ed6c0"
import script from "./add-driver.vue?vue&type=script&lang=js"
export * from "./add-driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports